module.exports = __webpack_public_path__ + "static/birth-spacing-6e06b48e42e5a9a2d0384bcb6623b393.png";